import { isUndefined } from '@aloft/toolkit-shared';

import { ValueFormatter } from '../../types.js';

export const calculations: ValueFormatter = (calculations: string[] | undefined) => {
  if (isUndefined(calculations)) {
    return { str: [''] };
  }

  return {
    str: calculations,
  };
};
